import { z } from "zod";

export const questionSchema = z.object({
  id: z.number(),
  content: z.string(),
  points: z.number(),
  answer: z.number().optional(),
});

export const answeredQuestionSchema = questionSchema.extend({
  answer: z.number(),
});

export type Question = z.infer<typeof questionSchema>;
export type AnsweredQuestion = z.infer<typeof answeredQuestionSchema>;
